export const translateClassType = (type: string): string => {
  const types = {
    english: 'Inglês',
    core: 'Core',
    club: 'Clube'
  };

  return types[type];
};